export { default } from './TableFooter';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TableFooter/index.js
// module id = 855
// module chunks = 2